import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';

export const isBaseQueryError = (
  error?: FetchBaseQueryError | SerializedError,
): error is FetchBaseQueryError => {
  return (error as FetchBaseQueryError)?.data !== undefined;
};
